import { defineMessages } from 'react-intl';
import { ProductDuplicateSku } from '../code-constants';

export const messages = defineMessages({
  [ProductDuplicateSku]: {
    description: 'Combine Products as variants error message when sku matches an existing product sku',
    defaultMessage: 'Unable to combine products, Parent SKU must be unique.',
    id: 'qIlWZ1',
  },
});

export default ({ code }) => {
  return messages[code];
};
